module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.281715b0.png";